import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { HeavyText, LightItalicText } from './Style';
import { VinylDisc, VINYL_THEMES } from './UserBadge';
import { trackEvent } from '../analytics';

var CTAWrapper = styled.div`
  box-sizing: border-box;
  max-width: 410px;
  width: 100%;
  margin: 0 auto;
  padding: 1.25rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: white;
  border: 1px solid #ddd;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 12px;
`;

var TaglineRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
`;

var BrandName = styled.div`
  font-size: 1.1rem;
  margin-bottom: 0.35rem;
`;

var HeroLine = styled.p`
  color: #333;
  font-size: 0.95rem;
  line-height: 1.4;
  margin: 0 0 0.35rem;
`;

var Subtitle = styled.p`
  color: #999;
  font-size: 0.8rem;
  margin: 0.25rem 0 0;
`;

var ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

var CTAButton = styled(Link)`
  display: block;
  background: white;
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  color: black;
  font-weight: 700;
  font-size: 0.8rem;
  width: 100%;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  box-sizing: border-box;
`;

var SIGNUP_VARIANTS = [
  { hero: 'An endless mixtape, curated by your friends.', subtitle: 'Discover and share music.' },
  { hero: 'Social media as a love letter to music.', subtitle: 'Discover and share music.' },
];

function SignupCTA(props) {
  var style = props.style;
  var children = props.children;
  var hideButtons = props.hideButtons;

  var _variant = useState(function () {
    return Math.floor(Math.random() * SIGNUP_VARIANTS.length);
  });
  var variantIdx = _variant[0];
  var variant = SIGNUP_VARIANTS[variantIdx];

  var tracked = useRef(false);
  useEffect(
    function () {
      if (tracked.current) return;
      tracked.current = true;
      trackEvent('signup_cta_viewed', { variant: variantIdx, hero: variant.hero });
    },
    [variantIdx, variant.hero]
  );

  return (
    <CTAWrapper style={style}>
      <TaglineRow>
        <VinylDisc theme={VINYL_THEMES.test_pressing} size={64} spinning />
        <div>
          <BrandName>
            <HeavyText>Heavy</HeavyText>
            <LightItalicText>Rotation</LightItalicText>
          </BrandName>
          <HeroLine>{variant.hero}</HeroLine>
          <Subtitle>{variant.subtitle}</Subtitle>
        </div>
      </TaglineRow>
      {children}
      {!hideButtons && (
        <ButtonRow>
          <CTAButton to="/signup">Sign up</CTAButton>
          <CTAButton to="/login">Already have an account? Log in</CTAButton>
        </ButtonRow>
      )}
    </CTAWrapper>
  );
}

// A one-line version for pages where the content should lead, such as a list
// opened from a digest email or a shared link: same copy and same view event
// as the full card, a fraction of the height.
var BarWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 400px;
  margin: 0 auto 0.75rem;
  background: #000;
  color: #fff;
  border-radius: 10px;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`;

var BarText = styled.span`
  font-size: 0.85rem;
`;

var BarButton = styled(Link)`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0 1rem;
  background: #fff;
  color: #000;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.8rem;
  text-decoration: none;
`;

export function SignupBar() {
  var tracked = useRef(false);
  useEffect(function () {
    if (tracked.current) return;
    tracked.current = true;
    // Its own event: signup_cta_viewed carries the card's numeric hero variant,
    // and mixing the bar into it would skew that comparison.
    trackEvent('signup_bar_viewed', { page: 'list' });
  }, []);

  return (
    <BarWrapper>
      <BarText>Discover and share music.</BarText>
      <BarButton to="/signup">Sign up</BarButton>
    </BarWrapper>
  );
}

export default SignupCTA;
